import React, { useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { AppDataContext } from '../common/AppContext';

const GoogleRecaptchaWrapper = ({ children, ...rest }) => {

    const { sitekey, getSiteKey } = React.useContext(AppDataContext);

    useEffect(() => {
        if (sitekey!='' && sitekey!=undefined) {
            console.log("Google ReCaptcha site key is set.");
        } else {
            getSiteKey();
        }
    }, [sitekey])

    return (
        <>
            {sitekey != '' && <GoogleReCaptchaProvider
                reCaptchaKey={sitekey}
                scriptProps={{
                    async: true,
                    defer: true,
                    appendTo: 'head',
                }}
            >
                {children}
            </GoogleReCaptchaProvider>}
        </>
    );
};

export default GoogleRecaptchaWrapper;
